import React, { Component } from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, 
    YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";
import { getArendeNyaOppnaPagaendeAlder,setofUpdatedashboardArende,decrypt,encrypt } from 'actions'
import {isEmpty,isUndefined, isEqual} from 'lodash'
import {Grid} from '@material-ui/core'
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';

const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span style={{ color }}>{value}</span>;
}

class Aktiviteter extends Component {
  state={
    DashboardAnpassadFilterOption:[],
    ArendeOppnaPagaende:[],
    intervaltype:0,
    done: false
  }
  intervalID = null
  componentDidMount=()=>{ 
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    axios.get(`kontos/DashBoard/getAOPA`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
          ArendeOppnaPagaende:ndate.results.ArendeOppnaPagaende,
          intervaltype:this.props.intervaltype
       });
       this.initiateInterval()  
    }
     })
         
      }
      initiateInterval() {
          clearInterval(this.intervalID);
          this.intervalID= null
    this.intervalID = setInterval(
      () => {         
          this.setState({done: false}) 
          const userid = this.props.authUser.user_id;
          const Afid = this.props.authUser.user_Afid;
          axios.get(`kontos/DashBoard/getAOPA`,
          { params:encrypt(JSON.stringify({
              Afid:Afid,
              FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
              intervaltype:this.props.intervaltype,
              userid:userid
            }))
          })
          .then(res => {
              if(res.data.success){
                                                                                        let endata = decrypt(res.data.encryptedData,res.data.iv)
                                                                                        let ndate = JSON.parse(endata)
                                                                                        this.setState({ 
                                                                                          ArendeOppnaPagaende:ndate.results.ArendeOppnaPagaende,
                                                                                          intervaltype:this.props.intervaltype
                                                                                       });
                                                                                       this.initiateInterval()  
                                                                                    }
           
            
           // this.setState({done: true})   
           })
      },
      180000
  );
  console.log('test1234567', this.props.height)
}
componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
  const userid = this.props.authUser.user_id;
  const Afid = this.props.authUser.user_Afid;
  if(parseInt(this.props.updatedashboardArende) === 1){
    axios.get(`kontos/DashBoard/getAOPA`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
          ArendeOppnaPagaende:ndate.results.ArendeOppnaPagaende,
          intervaltype:this.props.intervaltype
       });
       this.initiateInterval()  
    }
     })
    this.props.setofUpdatedashboardArende()
  }
  if(!isEqual([...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],this.state.DashboardAnpassadFilterOption)){   
    axios.get(`kontos/DashBoard/getAOPA`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
          ArendeOppnaPagaende:ndate.results.ArendeOppnaPagaende,
          intervaltype:this.props.intervaltype
       });
       this.initiateInterval()  
    } 
     })
    /* */
    this.setState({
      DashboardAnpassadFilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption] 
    }) 
  }
  if(this.state.intervaltype !== this.props.intervaltype){
    axios.get(`kontos/DashBoard/getAOPA`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[...this.props.filterOptionsArr, ...this.props.DashboardAnpassadFilterOption],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
          ArendeOppnaPagaende:ndate.results.ArendeOppnaPagaende,
          intervaltype:this.props.intervaltype
       });
       this.initiateInterval()  
    } 
     })
  }
}
createData=()=>{
  if(isEmpty(this.state.ArendeOppnaPagaende)){return [
    {name:"Aktuellt",Antal1:0, Antal2: 0},
    {name:"7 dagar",Antal1:0, Antal2: 0},
    {name:"15 dagar",Antal1:0, Antal2: 0},
    {name:"30 dagar",Antal1:0, Antal2: 0},
  ]}
  else{
    return this.state.ArendeOppnaPagaende
    }
}
formatNumber=(number)=>{
  if(number > 1000000){
    return `${(number/1000).toFixed(0).replace(/\d(?=(\d{3})+\.)/g, '$& ')}K`
}
  else if(number >= 1000){
    return `${(number/1000).toFixed(0)}K`
}else{
  return number
}
}
render() {
    return (
      <div className="text-center potition-relative" style={{ color: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, height: 'calc(100% - 12px)', paddingBottom: 20, overflow: 'hidden' }}>
                <div className="d-flex justify-content-center row" style={{ marginTop: '12px' }}>
                    <h2 className="col" style={{fontWeight:"500"}}><b><IntlMessages id="Errand"/></b></h2>
                {/*   <div style={{ marginTop: '-14px', marginRight:'10px' }}>
                        <CustomMenu />
                    </div>*/}
                </div>
                <div className="d-flex justify-content-center align-items-center" style={{height: 'calc(100% - 50px)'}}>
          <Grid container>
            <svg width="300" height="200" style={{position: 'absolute', pointerEvents: 'none', bottom: '150px'}}>
              <linearGradient id="linearColors5"  x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#44D1C2" />
              <stop offset="100%" stopColor="#44D1C2" />
              </linearGradient>
              <linearGradient id="linearColors6"  x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="#C377E0" />
              <stop offset="100%" stopColor="#C377E0" />
              </linearGradient>
            </svg>
            <Grid xs={12} item style={{color: '#fff'}}>
                <ResponsiveContainer className="gx-barchart" width="95%" height={this.props.height >= 100 ? this.props.height : 200}>
            <BarChart
            // data={data}
            data={this.createData()}
            margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
            >
            <XAxis stroke="#ffffff66" tick={{ fill: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor }} dataKey="name" />
            <YAxis stroke="#ffffff66" tick={{ fill: isUndefined(this.props.FontColor)?'#fff':this.props.FontColor}} domain={[0, 'dataMax + 1']} allowDecimals={false} type="number" tickFormatter={tick => {
                  return this.formatNumber(tick)
                }}/>
            <Tooltip cursor={{ stroke: '#0E898F40', strokeWidth: 1, fill: "#0E898F40" }} 
            formatter={(value) => this.formatNumber(value)}  
            labelStyle={{ color: "#075A5F" }}
            itemStyle={{ color: "#075A5F" }}
            />
            <Legend formatter={renderColorfulLegendText} iconType="circle" />
            <Bar name={this.props.intl.formatMessage({ id: 'DashBoard.Errand.Opened' })} dataKey="Antal1" fill="#44D1C2" barSize={20} radius={[30, 30, 0, 0]} />
            <Bar name={this.props.intl.formatMessage({ id: 'Label.Ongoing.Errand' })} dataKey="Antal2" fill="#C377E0"  barSize={20} radius={[30, 30, 0, 0]} />
            </BarChart>
            </ResponsiveContainer>
            </Grid>
        </Grid> 
      </div>
    </div>
  );
}
};

const mapStateToProps = ({ settings,auth,DashBoard,accountsData }) => {
  const { width } = settings;
  const { authUser} = auth;
  const { updatedashboardArende} = accountsData;
  const { ArendeOppnaPagaende,DashboardAnpassadFilterOption} = DashBoard;
  return { width,authUser,ArendeOppnaPagaende,DashboardAnpassadFilterOption,updatedashboardArende };
};
function mapDispatchToProps(dispatch) {
  return {
    getArendeNyaOppnaPagaendeAlder: (Afid, userid,DashboardAnpassadFilterOption) => dispatch(getArendeNyaOppnaPagaendeAlder(Afid, userid, DashboardAnpassadFilterOption)),
    setofUpdatedashboardArende: () => dispatch(setofUpdatedashboardArende()),
    decrypt: (encryptedData, iv) => dispatch(decrypt(encryptedData, iv)),
        encrypt: (data) => dispatch(encrypt(data)),
      dispatch
  }
}
export default compose(
  connect(mapStateToProps,mapDispatchToProps),
  injectIntl
)
(Aktiviteter);
